import { fg } from '@atlaskit/platform-feature-flags';

export default {
	get(): boolean {
		return fg('icp_ai_import');
	},
};
